import React from 'react'
import { Box, Link, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'

type EmptyStateProps = {
  title: string
  description?: string
  imageSrc?: string
}

const EmptyStateWrapper = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))

const EmptyStateImage = styled('img')(({ theme }) => ({
  width: 160,
  maxWidth: '100%',
  marginBottom: theme.spacing(3),
  opacity: 0.9,
}))

const EmptyStateTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 600,
  marginBottom: theme.spacing(1),
  color: theme.palette.text.primary,
}))

const EmptyStateDescription = styled(Typography)({
  fontSize: 14,
})

const EmptyStateGuideHint = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  marginTop: theme.spacing(1.5),
}))

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  imageSrc,
}) => {
  return (
    <EmptyStateWrapper>
      {imageSrc && <EmptyStateImage src={imageSrc} alt={title} />}

      <EmptyStateTitle>{title}</EmptyStateTitle>

      {description && (
        <EmptyStateDescription>{description}</EmptyStateDescription>
      )}

      <EmptyStateGuideHint>
        New here?{' '}
        <Link component={RouterLink} to='/guide' underline='hover'>
          See everything you can do
        </Link>
      </EmptyStateGuideHint>
    </EmptyStateWrapper>
  )
}

export default EmptyState
